<template>
  <div class="constraints-section">
    <div class="title-container">
      <span class="title">Constraints</span>
      <InfoIcon :info-data="infoDetails['wr_constraints']" />
    </div>
    <div class="content-container">
      <div class="column-container">
        <ThemedColumnText
          top-text="Max. Wind Cruise Speed"
          :bottom-text="speedText(maxWindCruiseSpeed)"
        />
        <ThemedColumnText
          top-text="Max. Wind Service Speed"
          :bottom-text="speedText(maxWindServiceSpeed)"
        />
      </div>
      <div class="column-container">
        <ThemedColumnText
          top-text="Max. Wave Cruise Height"
          :bottom-text="heightText(maxWaveCruiseHeight)"
        />
        <ThemedColumnText
          top-text="Max. Wave Service Height"
          :bottom-text="heightText(maxWaveServiceHeight)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ThemedColumnText from "@/core/ThemedColumnText.vue";
import InfoIcon from "@/core/InfoIcon.vue";

import { mapState } from "vuex";
export default {
  name: "ExtraVoyageSettings",
  components: { ThemedColumnText, InfoIcon },
  computed: {
    ...mapState("main", ["infoDetails"]),
    ...mapState("weatherRouting/formModule", [
      "maxWindCruiseSpeed",
      "maxWindServiceSpeed",
      "maxWaveCruiseHeight",
      "maxWaveServiceHeight",
    ]),
  },
  methods: {
    speedText(value) {
      return `${value} kn`;
    },
    heightText(value) {
      return `${value} m`;
    },
  },
};
</script>

  <style scoped>
.constraints-section {
  background-color: var(--color-bg);
  padding: 10px;
  border-end-end-radius: inherit;
  border-end-start-radius: inherit;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text);
}
.title-container {
  display: flex;
  align-items: center;
}
.content-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 10px;
}
.column-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
